import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, X, Settings, LogIn } from 'lucide-react';
import { Button } from './ui/button';
import { useAuth } from '../context/AuthContext';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const handleAdminClick = () => {
    if (isAuthenticated) {
      navigate('/admin/dashboard');
    } else {
      navigate('/admin/login');
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <h1 className="text-3xl font-bold bg-gradient-to-r from-gray-900 via-gray-800 to-amber-700 bg-clip-text text-transparent">
              DUGEZ
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('products')}
              className="text-gray-700 hover:text-amber-700 transition-colors duration-300 font-medium"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className="text-gray-700 hover:text-amber-700 transition-colors duration-300 font-medium"
            >
              Prodotti
            </button>
            <button
              onClick={() => scrollToSection('benefits')}
              className="text-gray-700 hover:text-amber-700 transition-colors duration-300 font-medium"
            >
              Vantaggi
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-amber-700 transition-colors duration-300 font-medium"
            >
              Contattaci
            </button>
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-gradient-to-r from-amber-600 to-amber-700 hover:from-amber-700 hover:to-amber-800 text-white transition-all duration-300"
            >
              Contattaci
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleAdminClick}
              className="text-gray-600 hover:text-amber-700"
            >
              {isAuthenticated ? (
                <>
                  <Settings className="w-4 h-4 mr-2" />
                  Pannello Admin
                </>
              ) : (
                <>
                  <LogIn className="w-4 h-4 mr-2" />
                  Admin
                </>
              )}
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-700 hover:text-amber-700 transition-colors"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('products')}
                className="text-gray-700 hover:text-amber-700 transition-colors duration-300 font-medium text-left"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('products')}
                className="text-gray-700 hover:text-amber-700 transition-colors duration-300 font-medium text-left"
              >
                Prodotti
              </button>
              <button
                onClick={() => scrollToSection('benefits')}
                className="text-gray-700 hover:text-amber-700 transition-colors duration-300 font-medium text-left"
              >
                Vantaggi
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-gray-700 hover:text-amber-700 transition-colors duration-300 font-medium text-left"
              >
                Contattaci
              </button>
              <Button
                onClick={() => scrollToSection('contact')}
                className="bg-gradient-to-r from-amber-600 to-amber-700 hover:from-amber-700 hover:to-amber-800 text-white w-full transition-all duration-300"
              >
                Contattaci
              </Button>
              <Button
                variant="outline"
                onClick={handleAdminClick}
                className="w-full"
              >
                {isAuthenticated ? (
                  <>
                    <Settings className="w-4 h-4 mr-2" />
                    Pannello Admin
                  </>
                ) : (
                  <>
                    <LogIn className="w-4 h-4 mr-2" />
                    Login Admin
                  </>
                )}
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};